module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-8.adca0037.png";